import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Element } from 'react-scroll';
import { propBool, propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SeminarOneFormAddButton from '../Parts/SeminarOneFormAddButton';
import SeminarOneFormFieldDescription from '../Parts/SeminarOneFormFieldDescription';
import SeminarOneFormFieldTitle from '../Parts/SeminarOneFormFieldTitle';
import SeminarOneFormLiaisonsFieldArrayInner from './SeminarOneFormLiaisonsFieldArrayInner';
/**
 * 問合せ窓口のコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormLiaisonsFieldArray = (props) => {
    const { change, className, disabled, mutators, name: fieldName, validates, } = props;
    /**
     * 「問合せ窓口を追加」クリック時のイベント
     * @type {(function())|*}
     */
    const onClickAdd = useCallback(() => {
        mutators.push(fieldName, {});
    }, [fieldName, mutators]);
    return (_jsx(Element, Object.assign({ className: className, name: `${fieldName}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_liaisons' }, { children: [_jsx(SeminarOneFormFieldTitle, { className: 'liaisons_title', text: '問い合わせ窓口' }), _jsx(SeminarOneFormFieldDescription, { className: 'liaisons_description', text: 'セミナーの申込や、個別開催の希望があった際のご連絡先を登録してください' }), _jsx("div", Object.assign({ className: 'liaisons_field' }, { children: _jsxs("div", Object.assign({ className: 'field_inner' }, { children: [_jsx("div", Object.assign({ className: 'field_rows' }, { children: _jsx(FieldArray, Object.assign({ name: fieldName }, { children: ({ fields }) => fields.map((name, index) => (_jsx(SeminarOneFormLiaisonsFieldArrayInner, { change: change, className: 'field_row', disabled: disabled, fields: fields, index: index, name: name, validates: validates }, name))) })) })), _jsx("div", Object.assign({ className: 'field_add' }, { children: _jsx(SeminarOneFormAddButton, { className: 'add_button', disabled: disabled, onClick: onClickAdd, text: '問い合わせ窓口を追加' }) }))] })) }))] })) })));
};
SeminarOneFormLiaisonsFieldArray.propTypes = {
    change: propFunc().isRequired,
    className: propStr(),
    disabled: propBool(),
    mutators: propShape().isRequired,
    name: propStr().isRequired,
    validates: propShape().isRequired,
};
SeminarOneFormLiaisonsFieldArray.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormLiaisonsFieldArray;
